import { render, staticRenderFns } from "./ResourceTableColumn.vue?vue&type=template&id=5e60d082&"
import script from "./ResourceTableColumn.vue?vue&type=script&lang=ts&"
export * from "./ResourceTableColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports